import { render } from "./ShimmerFolder.vue?vue&type=template&id=619dd8d6"
import script from "./ShimmerFolder.vue?vue&type=script&lang=js"
export * from "./ShimmerFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__